export default __webpack_public_path__ + "assets/img/Survey_List.0a15e5c9.svg";